var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconInfo = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("g", { transform: "translate(-4.167 -4.167)" },
                React.createElement("path", { d: "M31.1,19.2c0,6.6-5.3,11.9-11.9,11.9S7.2,25.8,7.2,19.2c0-6.6,5.3-11.9,11.9-11.9c0,0,0,0,0,0\n\t\t\t\t\t\t\tC25.8,7.2,31.1,12.6,31.1,19.2z" }),
                React.createElement("path", { d: "M19.2,23.9v-4.8" }),
                React.createElement("path", { d: "M19.2,14.4L19.2,14.4" })))));
});
export default IconInfo;
//# sourceMappingURL=IconInfo.js.map